module.exports = {
  isHttps: false // 上层服务是https或者http

};